import { useCallback, useEffect, useMemo } from 'react'
import { useSelector } from '@/libs/state'
import { listBalances } from '../application/list-balances'
import { balances$ } from '../store'
import { timeoff, notify } from '../wiring'
import { usePermission } from '@/features/permissions/hooks/use-permission'
import { useMembers } from '@/features/hr/hooks/use-members'
import { session$ } from '@/features/auth/store'
import { useDeptMemberIds } from '@/features/hr/hooks/use-dept-member-ids'

const useBalances = () => {
	const balances = useSelector(balances$)
	const canViewDept = usePermission('hr.time-off.view-dept')
	const canViewTeam = usePermission('hr.time-off.view-team')
	const canViewAll = usePermission('hr.time-off.view-all')
	const user = useSelector(() => session$.user.get())
	const { members } = useMembers(null, null)

	const memberId = useMemo(() => members.find(m => m.email === user?.email)?.id ?? null, [members, user?.email])

	const mustScopeToDept = !canViewAll && !canViewTeam && canViewDept
	const { memberIds } = useDeptMemberIds(mustScopeToDept ? memberId : null)

	const reload = useCallback(async () => {
		if (!memberId) {
			balances$.set([])
			return
		}
		const result = await listBalances(timeoff, memberId, notify, memberIds)
		balances$.set(result)
	}, [memberId, memberIds])

	useEffect(() => {
		reload()
	}, [reload])

	return { balances, reload }
}

export { useBalances }
